import type { GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import AccountLayout from '@components/common/AccountLayout'
import { Orders as OrdersPage } from '@corratech/pylot-orders'
import { getStoreConfig } from 'config'

export const getStaticProps: GetStaticProps = async ({
    locale
}: GetStaticPropsContext) => {
    return {
        props: {
            ...(await serverSideTranslations(locale!, ['common', 'account']))
        },
        revalidate: 14400
    }
}

export default function Orders(): JSX.Element {
    const config = getStoreConfig()
    return <OrdersPage reorderAllow={config.base.reorderAllow} />
}

Orders.Protected = true
Orders.Layout = AccountLayout
